import { useQuery } from '@tanstack/react-query';
import { get } from 'api/base';
import type { TextBuildingBlock } from 'types/textBuildingBlocks';

export function useTextBuildingBlocks() {
  return useQuery({
    queryKey: ['textBuildingBlocks'],
    queryFn: async () => {
      const data = await get('textBuildingBlocks');
      return data as TextBuildingBlock[];
    },
    staleTime: Infinity,
  });
}
